import React from 'react'

import WrongAnswerButton from '@components/Button/WrongAnswerButton/WrongAnswerButton'

type WrongAnswerButtonContainerProps = {
  isWrong: boolean
  choiceNumber: number
  toggleWrongChoice: (choice: number) => void
}

const WrongAnswerButtonContainer: React.FC<WrongAnswerButtonContainerProps> = ({
  isWrong,
  choiceNumber,
  toggleWrongChoice,
}) => {
  const setCurrentWrong = () => {
    toggleWrongChoice(choiceNumber)
  }

  const props = {
    isWrong,
    wrongButtonHandler: setCurrentWrong,
  }
  return <WrongAnswerButton {...props} />
}

export default React.memo(WrongAnswerButtonContainer)
